module.exports = __webpack_public_path__ + "img/edge_activites_bateau.6483dbd8.svg";